import i18n from "i18next";
import ReactDOM from "react-dom/client";
import { initReactI18next } from "react-i18next";
import { QueryClientProvider } from "react-query";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import config from 'devextreme/core/config'; 

import englishJson from "./lang/en.json";
import frenchJson from "./lang/fr.json";
import pagesRouter from "./routes/browser-router.tsx";
import queryClient from "./services/data/query.ts";

import licenseKey from './devextreme-license';

import '@fontsource-variable/inter/opsz-italic.css';
import '@fontsource/open-sans';
import "@splidejs/react-splide/css";
import "react-toastify/dist/ReactToastify.css";

import "./styles/tailwind.css";
import "./styles/index.css";
import "./styles/global.css";
import "./styles/deoverride.css";
import "./styles/twoverride.css"

import ProjectProcessRunnerProvider from "./services/context/project-process/project-process-runner-provider";
import IndicatorsContextProvider from "./services/context/indicators-context-provider/indicators-context-provider.tsx";
import LocationContextProvider from "./services/context/location/location-context-provider.tsx";
import ProjectFilterNumberProvider from "./services/context/project-filter-number/project-filter-number-provider.tsx";
import AuthenticationContextProvider from "./services/context/authentication/authentication-context-provider.tsx";
import ProjectOrderByProvider from "@/services/context/project-order-by/project-order-by-provider.tsx";
import PreventNavigationProvider from "@/services/context/prohibit-nagivation/prevent-navigation-provider.tsx";

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            en: { translation: englishJson },
            fr: { translation: frenchJson },
        },
        lng: "fr", // if you're using a language detector, do not define the lng option
        fallbackLng: "fr",

        interpolation: {
            escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        },
    });

config({ licenseKey });

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <QueryClientProvider client={queryClient}>
        <AuthenticationContextProvider>
            <ProjectProcessRunnerProvider>
                <IndicatorsContextProvider>
                    <LocationContextProvider>
                        <ProjectFilterNumberProvider>
                            <PreventNavigationProvider>
                                <ProjectOrderByProvider>
                                    <RouterProvider router={pagesRouter}/>
                                    <ToastContainer position="bottom-right"
                                                    closeButton={true}
                                                    autoClose={5000}
                                                    hideProgressBar={true}
                                                    newestOnTop={false}
                                                    closeOnClick
                                                    rtl={false}
                                                    pauseOnFocusLoss
                                                    pauseOnHover
                                                    theme="light"/>
                                </ProjectOrderByProvider>
                            </PreventNavigationProvider>
                        </ProjectFilterNumberProvider>
                    </LocationContextProvider>
                </IndicatorsContextProvider>
            </ProjectProcessRunnerProvider>
        </AuthenticationContextProvider>
    </QueryClientProvider>
);
